import * as Sentry from "@sentry/vue";
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import {
    AlertPlugin,
    AvatarPlugin,
    ButtonPlugin,
    FormCheckboxPlugin,
    FormGroupPlugin,
    FormInputPlugin,
    FormTextareaPlugin,
    InputGroupPlugin,
    LinkPlugin,
    ModalPlugin,
    NavPlugin,
    OverlayPlugin,
    PopoverPlugin,
    SpinnerPlugin,
    TablePlugin,
    TooltipPlugin
} from "bootstrap-vue";
import { RewriteFrames } from "@sentry/integrations";
import {Router} from 'ziggy-js';


declare global {
    // const $page: Page;
    function route(): Router;
    function route(name?: string, params?: any, absolute?: boolean, customZiggy?: any): string;
}

Sentry.init({
    Vue,
    dsn: 'https://ce131f2836b74a5188d984f9f402f8ee@o605493.ingest.sentry.io/5744831',

    // Display errors to
    logErrors: true,

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    // release: "my-project-name@2.3.12",
    // integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    // tracesSampleRate: 1.0,
    integrations: [
        new RewriteFrames({
            // @ts-ignore
            root: global.__rootdir__,
        }),
    ]
});

// Vue.config.errorHandler = function(err, vm, info) {
//     console.error('Vue caught error', err);
// }


Vue.mixin({methods: {route}});
Vue.use(VueCompositionAPI);
/**
 * Bootstrap-vue that is being used on frontend and backend
 */
Vue.use(AvatarPlugin);
Vue.use(ButtonPlugin);
Vue.use(SpinnerPlugin);
// Use vue-toastification instead
// Vue.use(ToastPlugin);
Vue.use(PopoverPlugin);
Vue.use(TooltipPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormInputPlugin);
Vue.use(InputGroupPlugin);
Vue.use(LinkPlugin);
Vue.use(ModalPlugin);
Vue.use(AlertPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(TablePlugin);
Vue.use(NavPlugin);
Vue.use(OverlayPlugin);